import { useEffect } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuth } from '../authNew/authSlice';
import { ADMIN_EMAIL } from './adminConstants';
import { showToast } from './toastService';

// Guards admin-only routes and redirects with a toast when access is denied.
export function AdminGuard() {
    const auth = useSelector(selectAuth);
    const navigate = useNavigate();
    const location = useLocation();
    const normalizedEmail = (auth.email || '').toLowerCase();
    const isAdminUser = auth.isLogged && normalizedEmail === ADMIN_EMAIL;

    // Sends non-admin users back home and shows a toast when they attempt access.
    useEffect(() => {
        if (!isAdminUser) {
            showToast({
                severity: 'warn',
                summary: 'Accesso negato',
                detail: 'Solo l\'amministratore puo\' accedere a questa pagina.'
            });
            navigate('/', { replace: true, state: { from: location.pathname } });
        }
    }, [isAdminUser, navigate, location.pathname]);

    if (!isAdminUser) {
        return null;
    }

    return <Outlet />;
}
